fragment CategoryBarIconsFragment on categoryBarIcons_Entry {
  typeHandle
  icons: categoryBarIcons {
    ... on categoryBarIconsBlock_Entry {
      id
      icon {
        url
      }
      cta {
        ...LinkFragment
      }
    }
  }
}
